// extracted by mini-css-extract-plugin
module.exports = {"fontAwesome":"core_fontAwesome_ozpun"};